import { render } from "./modalsearch.vue?vue&type=template&id=f2e97da6&scoped=true"
import script from "./modalsearch.vue?vue&type=script&lang=js"
export * from "./modalsearch.vue?vue&type=script&lang=js"

import "./modalsearch.vue?vue&type=style&index=0&id=f2e97da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e97da6"]])

export default __exports__